<!-- Selection of coordinate system -->

<div style="height: 100% !important; font-size: 14px" class="ml-2 mt-2 mb-2">
  <div mat-dialog-title>{{data.title | translate }}</div>
  <div mat-dialog-content>
    <mat-form-field>
      <input [formControl]="searchEPSGControll" class="full-width" #searchEPSG type="text" [value]="data.incoming"
             [placeholder]="'MAP.PHOTOGRAM.SEARCHG_EPSG_CODE' | translate" matInput>
    </mat-form-field>
    <button mat-raised-button (click)="setDefaultEPSGCode()" color="primary"
            class="ml-2"
    >{{'MAP.PHOTOGRAM.APPLY_DEFAULT' | translate }}
    </button>
    <button mat-raised-button (click)="dialogRef.close('Local');" color="primary"
            *ngIf="data.showLocalButton"
            class="ml-2"
    >{{'MAP.PHOTOGRAM.APPLY_LOCAL' | translate }}
    </button>

    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="datas" matSort matSortActive="name" matSortDirection="asc">

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'MAP.PHOTOGRAM.EPSG_NAME' | translate }}</th>
          <td mat-cell *matCellDef="let row"> {{row.name}}</td>
        </ng-container>

        <!-- EPSG Column -->

        <ng-container matColumnDef="epsg">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'MAP.PHOTOGRAM.EPSG' | translate }}</th>
          <td mat-cell *matCellDef="let row"> {{row.uid}}</td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row class="fdm-linked" [ngClass]="{'highlight': selectedRowIndex == row.id}"
            *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)">>
        </tr>
      </table>

      <mat-paginator #paginator [length]="resultsLength" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

  </div>

  <div mat-dialog-actions class="align-content-right">
    <button mat-raised-button [disabled]="selectedRowIndex == -1" (click)="dialogRef.close(selectedEPSGCode)"
            color="primary">{{'MAP.PHOTOGRAM.APPLY_SELECTED' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="dialogRef.close()">{{'GENERIC.CANCEL' | translate }}</button>
  </div>

</div>
